import React from 'react';
import {
  call,
  takeLatest,
  put,
  select,
} from 'redux-saga/effects';
import apiFetchImpcEdit from '../../api/ImpcEditAPI';
import { IMPC_EDIT_REQUEST } from '../actions/types/ImpcEditActionTypes';
import { putImpcEditSuccessActionCreator, putImpcEditFailureActionCreator } from '../actions/ImpcEditActions';
import { showNotification } from '../../../../common/redux/actions/NotificationActions';
import { formatMessage } from '../../../../../locales/locales';
import { languageSelector } from '../../../../common/redux/selectors/languageSelector';

function* doImpcEditWorker(action) {
  const lang = yield select(languageSelector);

  try {
    const res = yield call(apiFetchImpcEdit, action.payload);
    yield put(putImpcEditSuccessActionCreator(res.data));
    yield put(showNotification({
      type: 'SUCCESS',
      message: formatMessage(lang, 'notification.impc.edit.success'),
    }));
  } catch (error) {
    yield put(putImpcEditFailureActionCreator(error));
    yield put(showNotification({
      type: 'ERROR',
      message: formatMessage(lang, 'notification.impc.edit.failure'),
    }));
  }
}

function* doImpcEditWatcher() {
  yield takeLatest(IMPC_EDIT_REQUEST, doImpcEditWorker);
}

export default doImpcEditWatcher;
